import { formatIntervalo, obraTitulo } from "../../../resolver-conflito/resolver-conflito.utils";
import {
  diasDoConflito,
  escopoEmConflito,
  listarObras,
  plural,
} from "../../resolver-conflito-fornecedor.utils";
import type {
  EscoposFornecedorStepProps,
  EscoposFornecedorStepViewModel,
} from "./types-escopos-fornecedor-step";

/**
 * Etapa 1 (Escopos): obra em que o fornecedor será substituído (qualquer quantidade de obras do
 * conflito) e o escopo macro dela, exibido como informação da carga.
 */
export function useEscoposFornecedorStep({
  fornecedor,
  conflito,
  escoposPorAlocacao,
  alocacaoId,
  escopoId,
  erroObra,
  escolherObra,
  escolherEscopo,
}: EscoposFornecedorStepProps): EscoposFornecedorStepViewModel {
  const alocacao = conflito.alocacoes.find((item) => item.id === alocacaoId) ?? null;
  const escopos = (alocacao ? escoposPorAlocacao[alocacao.id] : undefined) ?? [];
  const outras = conflito.alocacoes.filter((item) => item.obra.id !== alocacao?.obra.id);
  const escopoSelecionado = escopos.find((item) => item.id === escopoId) ?? null;

  const resolveSobreposicao =
    escopoSelecionado && escopoEmConflito(escopoSelecionado, conflito) && outras.length > 0;

  return {
    fornecedorNome: fornecedor.nome,
    sobreposicao: `Sobreposição de ${plural(diasDoConflito(conflito), "dia", "dias")} entre ${listarObras(
      conflito.alocacoes.map((item) => item.obra),
    )}.`,
    obras: conflito.alocacoes.map((item) => {
      const total = escoposPorAlocacao[item.id]?.length ?? 0;
      return {
        id: item.id,
        titulo: obraTitulo(item.obra),
        meta: `${fornecedor.nome} na obra: ${formatIntervalo(item)}${
          total > 0 ? ` · ${plural(total, "escopo macro", "escopos macros")}` : ""
        }`,
        marcada: item.id === alocacaoId,
      };
    }),
    erroObra,
    escopos:
      alocacao && escopos.length > 0
        ? escopos.map((escopo) => ({
            id: escopo.id,
            titulo: escopo.escopo,
            meta: `${formatIntervalo(escopo)} · ${fornecedor.nome}`,
            emConflito: escopoEmConflito(escopo, conflito),
            marcado: escopo.id === escopoId,
          }))
        : null,
    escopoResumo: escopoSelecionado
      ? `1 escopo selecionado${
          resolveSobreposicao
            ? ` · resolve a sobreposição com ${listarObras(outras.map((item) => item.obra))}`
            : ""
        }`
      : null,
    escolherObra,
    escolherEscopo,
  };
}
